import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
import "../public/css/stileAlma.css"

Vue.config.productionTip = false

var v=new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')

window.myapp=v;